import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "booking-version" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgSprite = _resolveComponent("SvgSprite")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Snackbar = _resolveComponent("Snackbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SvgSprite),
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_component_Dialog),
    _createVNode(_component_Snackbar),
    (_openBlock(), _createBlock(_Teleport, { to: ".site-footer" }, [
      _createElementVNode("p", _hoisted_1, "v" + _toDisplayString(_ctx.version), 1)
    ]))
  ], 64))
}